import { connect } from 'react-redux'
import { State } from '../../dataStore/reducers/reducerType'
import DetailsSidePanel from './DetailsSidePanel'
import { DetailsSidePanelProps } from './types'

const mapStateToProps = (state: State): DetailsSidePanelProps => {

  const webcast = state.webcast.collection[`${state.config.channelId}${state.config.webcastId}`]
  return {
    webcast: (webcast && webcast.status.hasData) ? webcast.data : undefined,
    user: state.user.data 
  }

}

export default connect(mapStateToProps)(DetailsSidePanel)
